module.exports = __webpack_public_path__ + "img/BJFintech.0cc078b5.png";